export const Gray = {
  themeName: "Gray",
  isDark: false,
  CardViewBgColor: "#f1eef6bb",
  primary: "#222222",
  iconAppItem: "#222222",
  AppText: "#222222",
  loginFooter: "#222222",
  connectBtn: "#222222",
  label: "#222222",
  loader: "#222222",
  headerColor: "#222222",
  primaryDark: "#292929",
  offline: "#ec4545",
  offlineLabel: "#838383",
  primaryLight: "#51505040",
  primaryColor: "#515050B2",
  welcomeBg: "#CBDBDF",
  secondary: "#A6D536",
  focusedBorderLoginInput: "#A6D536",
  focusedLabelLoginInput: "#A6D536",
  resetInputLogin: "#A6D536",

  languageIcon: "#A6D536",

  secondaryLight: "#A6D53680",
  textColor: "#000",
  labelColor: "#8A8A8A",
  listBg: "#ffffff",
  containerLanguageIcon: "#ffffff",

  settingCollapseColor: "#eee",
  separatorColor: "#aaa",
  notFocusedLabelInput: "#aaa",

  fapMap: "#aaa",
  danger: "#EE6E6E",
  warning: "#e59d4b",
  welcomeBg: "#D7E3E3",
  success: "#3ecd7e",
  playerControl: "#FFFFFF30",
  whiteToast: "#FFF",
  loginText: "#FFF",
  blazeOrangeToast: "#FE6301",
  mantisToast: "#69C779",
  altoToast: "#D8D8D8",
  dustyGrayToast: "#979797",
  infoToast: "#6F53A3",
  yellowToast: "#edc300",
  greyToast: "#ccc",
  grayToast: "#aaa",
  lightToast: "#e5e2ec",
  appBg: "#f8f8f8",
  appBorder: "#e7e7e7",
  groupIcon: "#ffffff",
  loginBtnLabel: "#ffffff",

  borderRecord: "#51505040",
  borderFormInput: "#eee",
  SelectedDrawerItem: "#CBDBDF",
  swipableBg: "#ffffff",
  landingScreenModeBg: "#F3F3F3",
  calenderBorder: "#CBDBDF",
  cancelButton: "#eee",
  listPlaceHolder: "#eee",
  fapMapBg: "#ffffff",
  fapMapActive: "#222222",
  listBgCard: "#eee",
  noItemToDisplay: "#ccc",
  listItem: "#ffff",
  linkColor: "#1D9BF0",
  bgLoginInput: "#FFF",
  colorTextInput: "#000",
  LogincolorTextInput: "#000",
  LogincolorLabelInput: "#aaa",
  loginOptions: "#000",
  shadowBtnConnect: "#A6D536",
  bnConnect: "#222222",
  notfocusedBorderLoginInput: "#ffffff",
  headerPrimary: "#22222200",
  headerDark: "#29292900",
  headerText: "#222222",
  notificationUpColor: "#FAFAFA",
  notificationDownColor: "#F2F2F2",

  listItemNotificationUpColor: "#F7F7F7",
  listItemNotificationDownColor: "#EBEDEF",

  listItemOfflineUpColor: "#FFFFFF",
  listItemOfflineDownColor: "#EDEDED",

  notFocusedSocialMedia: "#222222",
  focusedSocialMedia: "#222222cc",
  loginBgFooter: "#fff",
  
  //Costum4
  loginFirstTabTitle:"#222",
  loginTabTitle:"#222",
  loginTabSelected:"#fff",
  loginTabNotSelected:"#ffffff4d",

  //Custom Languge Modal
  languageContainerLeft:"#fff",
  languageContainerRight:"#222222",
  submitLeftConnect:"#222",
  submitRightConnect:"#fff",

};
